// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lg-thumbnail-page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  /* border: 5px solid rgb(240, 236, 236);
	box-shadow: 5px 5px 5px lightgrey; */
  width: 600px;
  height: fit-content;
  border: 1px solid grey;
}

.lg-thumbnail-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  background: white;

  width: 84%;
  height: 100%;
  margin-bottom: 20px;
}

.lg-thumbnail-img__wrapper {
  position: relative;
}

.lg-thumbnail-img {
  object-fit: scale-down;
  height: 325px;
  width: 100%;
  /* border: 2px solid grey; */
  /* border-bottom: 0; */
}

.lg-thumbnail-title {
  display: flex;
  margin: 0;
  background: black;
  color: white;
  width: -webkit-fill-available;
}

.lg-thumbnail-info {
  margin-top: 20px;
}

/* .lg-thumbnail-info p {
	margin: 0;
} */

.lg-thumbnail-button {
  display: flex;
  justify-content: center;
  /* width: 4%; */
  background: white;
  align-self: flex-end;
  border: none;
  padding: 0;
  margin: 0;
}

/* .lg-thumbnail-button img {
	margin: -7px;
} */

.lg-thumbnail-desc {
  align-self: center;
  width: 80%;
}

.tech-list {
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
}

.lg-thumbnail__sources p {
  margin-left: 15px;
}

@media (max-width: 650px) {
  .modal-content {
    width: 600px;
    position: absolute;
    top: 0;
  }
  .lg-thumbnail-page-wrapper {
    width: 100%;
    border: none;
    box-shadow: none;
  }
}

@media (max-width: 600px) {
  .modal-content {
    width: 100%;
  }
}

@media (max-width: 400px) {
  .lg-thumbnail-title {
    font-size: 25px;
  }
}

@media (min-height: 1000px) {
  .modal {
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/lg-thumbnail/lg-thumbnail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;qCACmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;;EAE7B,iBAAiB;;EAEjB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;EACR;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".lg-thumbnail-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  /* border: 5px solid rgb(240, 236, 236);\n\tbox-shadow: 5px 5px 5px lightgrey; */\n  width: 600px;\n  height: fit-content;\n  border: 1px solid grey;\n}\n\n.lg-thumbnail-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n\n  background: white;\n\n  width: 84%;\n  height: 100%;\n  margin-bottom: 20px;\n}\n\n.lg-thumbnail-img__wrapper {\n  position: relative;\n}\n\n.lg-thumbnail-img {\n  object-fit: scale-down;\n  height: 325px;\n  width: 100%;\n  /* border: 2px solid grey; */\n  /* border-bottom: 0; */\n}\n\n.lg-thumbnail-title {\n  display: flex;\n  margin: 0;\n  background: black;\n  color: white;\n  width: -webkit-fill-available;\n}\n\n.lg-thumbnail-info {\n  margin-top: 20px;\n}\n\n/* .lg-thumbnail-info p {\n\tmargin: 0;\n} */\n\n.lg-thumbnail-button {\n  display: flex;\n  justify-content: center;\n  /* width: 4%; */\n  background: white;\n  align-self: flex-end;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* .lg-thumbnail-button img {\n\tmargin: -7px;\n} */\n\n.lg-thumbnail-desc {\n  align-self: center;\n  width: 80%;\n}\n\n.tech-list {\n  padding: 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.lg-thumbnail__sources p {\n  margin-left: 15px;\n}\n\n@media (max-width: 650px) {\n  .modal-content {\n    width: 600px;\n    position: absolute;\n    top: 0;\n  }\n  .lg-thumbnail-page-wrapper {\n    width: 100%;\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .modal-content {\n    width: 100%;\n  }\n}\n\n@media (max-width: 400px) {\n  .lg-thumbnail-title {\n    font-size: 25px;\n  }\n}\n\n@media (min-height: 1000px) {\n  .modal {\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
